module.exports = __webpack_public_path__ + "img/scene-bg.png";